import './ValidationRuleMetadataTab.scss';
import { CodeHighlight } from '@ui/general';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PERISCOPE_VALIDATION_RULE_COPY } from '@sonar-software/sonar-ts-constants';
import { DetailSection, DetailSubsection } from '@periscopes/general';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
import { usePeriscopeActions, usePeriscopeMetadata } from '@hooks';
export const ValidationRuleMetadataTab = ({ displayName, index, sonarObjectId }) => {
    const { openPeriscope } = usePeriscopeActions();
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.SalesforceValidationRule);
    const childName = `.${displayName}`;
    const handleEntityClick = useCallback(() => {
        if (!metadata) {
            return;
        }
        openPeriscope({
            id: metadata.parentSonarObjectId,
            name: metadata.parentDisplayName,
            openLeft: true,
            openedFromIndex: index,
            type: SonarObjectType.SalesforceEntity
        });
    }, [index, metadata, openPeriscope]);
    if (!metadata || loading) {
        return React.createElement(LoadingSpinner, { spinning: true });
    }
    return (React.createElement(DetailSection, { className: 'validation-rule-metadata' },
        React.createElement(DetailSubsection, { title: PERISCOPE_VALIDATION_RULE_COPY.CODE_SNIPPET },
            React.createElement(CodeHighlight, { code: metadata.code, codeReferences: metadata.codeReferences, index: index })),
        React.createElement(DetailSubsection, { className: 'parent-object', title: PERISCOPE_VALIDATION_RULE_COPY.PARENT_OBJECT },
            React.createElement("span", { className: 'reference-link', onClick: handleEntityClick },
                React.createElement("b", null, metadata.parentDisplayName),
                childName))));
};
